import { OpportunityQueue } from "@/features/treasury/treasury";

export default function TreasuryOpportunitiesPage() {
  return <OpportunityQueue />;
}
